var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dynamic-object-form-structure", {
    attrs: {
      "object-uuid": _vm.objectUUID,
      "object-layer": _vm.objectLayer,
      "object-data": _vm.objectData,
      "loading-structure": _vm.loadingStructure,
      "loading-save": _vm.loadingSave,
      "permission-name": _vm.form.permission,
      "object-type-translation-key": _vm.form.name_translation,
      tabs: _vm.visibleTabs,
      "active-tab": _vm.activeTab,
      "action-type": _vm.actionType,
      "map-element": _vm.$parent.$refs.formsContainer,
      "previous-pos-x": _vm.previousPosX,
      "previous-pos-y": _vm.previousPosY,
      saveIsDisabled: !_vm.required.filled,
      "data-was-changed": _vm.dataWasChanged,
      "fields-still-need-filled": _vm.required.stillNeedFilled
    },
    on: {
      updateActiveTab: function($event) {
        _vm.activeTab = $event
      },
      changeViewMode: _vm.changeViewModeOfObject,
      openDetails: _vm.openDetails,
      refresh: _vm.refresh,
      clearData: _vm.clearData,
      save: _vm.saveObject,
      close: _vm.closeForm
    },
    scopedSlots: _vm._u([
      {
        key: "formFields",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "table",
                    expression: "visibleTabs[activeTab].type === 'table'"
                  }
                ],
                staticClass: "form tab-content"
              },
              [
                _vm.customerPremisesTable.loaded
                  ? _c("customer-premises-tab", {
                      attrs: {
                        layer: "fc_customer_premises",
                        editMode: !_vm.readOnly,
                        originalObjects: _vm.customerPremisesTable.objects
                          ? _vm.customerPremisesTable.objects
                          : [],
                        buildingUuid: _vm.customerPremisesTable.buildingUuid
                          ? _vm.customerPremisesTable.buildingUuid
                          : "",
                        "max-height": 400
                      },
                      on: { updateTotalOfHPs: _vm.updateTotalOfHPs }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "photos",
                    expression: "visibleTabs[activeTab].type === 'photos'"
                  }
                ],
                staticClass: "form tab-content"
              },
              [
                _c("forms-photo-section", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "images-list": _vm.imagesList,
                    "previous-images": _vm.previousImages
                  },
                  on: {
                    updatePhoto: _vm.updatePhoto,
                    removePhoto: _vm.addToPhotosToRemove
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "form",
                    expression: "visibleTabs[activeTab].type === 'form'"
                  }
                ],
                staticClass: "form tab-content"
              },
              [
                _vm._l(_vm.visibleTabs[_vm.activeTab].fields, function(field) {
                  return [
                    field.var_name === "bd_bld_city_code" &&
                    field.select_list_name === "list_cities_portugal"
                      ? _c(
                          "input-field",
                          {
                            key:
                              _vm.visibleTabs[_vm.activeTab].code +
                              field.label +
                              field.order,
                            attrs: {
                              value: _vm.getValueInObject(
                                field.var_name,
                                field.input_type
                              ),
                              label: field.label_client
                                ? field.label_client
                                : field.label,
                              "variable-name": field.var_name,
                              inputType: "other",
                              size: field.size,
                              required: field.required,
                              "required-filled": _vm.required.filled,
                              hide: field.hide,
                              fieldDisabled: field.disable,
                              tabDisabled: !_vm.userCanEditTabContent(
                                _vm.visibleTabs[_vm.activeTab]
                              ),
                              formDisabled: _vm.readOnly
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("treeselect", {
                                  staticClass: "form-input-select",
                                  attrs: {
                                    value: _vm.objectData.bd_bld_city_code,
                                    options: _vm.portugalCitiesOptions,
                                    normalizer:
                                      _vm.portugalCitiesOptionsNormalizer,
                                    disabled:
                                      _vm.readOnly ||
                                      !_vm.userCanEditTabContent(
                                        _vm.visibleTabs[_vm.activeTab]
                                      ) ||
                                      field.disable,
                                    disableFuzzyMatching: ""
                                  },
                                  on: { input: _vm.setValueCityCode }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : field.var_name === "bd_demand_point_locale_code" &&
                        field.select_list_name === "list_cities_locale_portugal"
                      ? _c(
                          "input-field",
                          {
                            key:
                              _vm.visibleTabs[_vm.activeTab].code +
                              field.label +
                              field.order,
                            attrs: {
                              value: _vm.getValueInObject(
                                field.var_name,
                                field.input_type
                              ),
                              label: field.label_client
                                ? field.label_client
                                : field.label,
                              "variable-name": field.var_name,
                              inputType: "other",
                              size: field.size,
                              required: field.required,
                              "required-filled": _vm.required.filled,
                              hide: field.hide,
                              fieldDisabled: field.disable,
                              tabDisabled: !_vm.userCanEditTabContent(
                                _vm.visibleTabs[_vm.activeTab]
                              ),
                              formDisabled: _vm.readOnly
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("treeselect", {
                                  staticClass: "form-input-select",
                                  attrs: {
                                    value:
                                      _vm.objectData
                                        .bd_demand_point_locale_code,
                                    options: _vm.portugalCitiesLocaleOptions,
                                    normalizer:
                                      _vm.portugalCitiesLocaleOptionsNormalizer,
                                    disabled:
                                      _vm.readOnly ||
                                      !_vm.userCanEditTabContent(
                                        _vm.visibleTabs[_vm.activeTab]
                                      ) ||
                                      field.disable ||
                                      !_vm.objectData.bd_bld_city_code,
                                    disableFuzzyMatching: ""
                                  },
                                  on: { input: _vm.setValueCityLocaleCode }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _c("input-field", {
                          key:
                            _vm.visibleTabs[_vm.activeTab].code +
                            field.label +
                            field.order,
                          ref: "formInputField",
                          refInFor: true,
                          attrs: {
                            value: _vm.getValueInObject(
                              field.var_name,
                              field.input_type
                            ),
                            label: field.label_client
                              ? field.label_client
                              : field.label,
                            "variable-name": field.var_name,
                            inputType: field.input_type,
                            size: field.size,
                            required: field.required,
                            "required-filled": _vm.required.filled,
                            selectOptions: field.select_list_name,
                            radioOptions: field.radio_options,
                            fieldDisabled: field.disable,
                            tabDisabled: !_vm.userCanEditTabContent(
                              _vm.visibleTabs[_vm.activeTab]
                            ),
                            formDisabled: _vm.readOnly,
                            hide: field.hide,
                            checkboxOptions: field.checkbox_options,
                            "object-data": _vm.objectData,
                            labelIsLocked: _vm.objectData.bd_label_locked,
                            "user-can-unlock-label": !_vm.userHasFibercloudPermission(
                              _vm.form.permission + "_manage_label"
                            )
                          },
                          on: {
                            input: function($event) {
                              return _vm.setValueInObject(
                                field.var_name,
                                $event,
                                field.input_type
                              )
                            },
                            "toggle-label-lock": _vm.changeLabelMode,
                            updateCheckboxValue: function($event) {
                              return _vm.updateCheckboxValue($event)
                            },
                            removePhoto: function($event) {
                              return _vm.addToPhotosToRemove($event)
                            }
                          }
                        })
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("building-operator-section", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.visibleTabs[_vm.activeTab].code === "building_operator",
                  expression:
                    "visibleTabs[activeTab].code === 'building_operator'"
                }
              ],
              attrs: {
                "original-operators": _vm.objectData,
                disabled: _vm.readOnly
              },
              on: {
                updateOperatorsList: function($event) {
                  return _vm.setValueInObject("building_operator", $event)
                },
                updateNumberOperators: function($event) {
                  return _vm.setValueInObject(
                    "bd_demand_point_num_operators",
                    $event
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("building-typification", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.visibleTabs[_vm.activeTab].code ===
                    "building_typification",
                  expression:
                    "visibleTabs[activeTab].code === 'building_typification'"
                }
              ],
              attrs: { "object-data": _vm.objectData, disabled: _vm.readOnly },
              on: {
                updateEntries: function($event) {
                  return _vm.setValueInObject("building_typification", $event)
                }
              }
            }),
            _vm._v(" "),
            _vm.visibleTabs[_vm.activeTab].code === "custom_fields"
              ? _c("custom-fields-tab", {
                  attrs: {
                    customFields: _vm.customFields.custom_fields,
                    objectData: _vm.objectData.custom_fields,
                    actionType: _vm.actionType,
                    disabled: _vm.readOnly,
                    requiredFilled: _vm.required.filled
                  },
                  on: { updateValue: _vm.setValueInObject }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleTabs[_vm.activeTab].code === "building_vertical"
              ? _c("vertical-planning-tab", {
                  attrs: {
                    "ground-floors-prop": _vm.buildingVertical.groundFloors,
                    "underground-floors-prop":
                      _vm.buildingVertical.undergroundFloors,
                    "columns-prop": _vm.buildingVertical.columns,
                    "technical-locals-prop":
                      _vm.buildingVertical.technicalLocals,
                    "action-type": _vm.actionType
                  },
                  on: {
                    "update-vertical-planning": function($event) {
                      return _vm.updateVerticalPlanning($event)
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "dialogBox",
        fn: function() {
          return [
            _c("app-dialog-box", {
              attrs: {
                open: _vm.dialog,
                isPersistent: true,
                title: _vm.$t("TechnicalSiteDialog.createTechnicalLocalTitle"),
                content: _vm.$t("TechnicalSiteDialog.createTechnicalLocalText"),
                "main-action-label": _vm.$t("Yes"),
                "secondary-action-label": _vm.$t("No")
              },
              on: {
                mainAction: function($event) {
                  return _vm.createTechnicalLocal("Building")
                },
                secondaryAction: _vm.closeDialog
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40872d07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40872d07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ObjectForms/BuildingForm.vue
// module id = null
// module chunks = 